export const LOCAL_STORAGE_KEYS = {
  LOGIN_DATA: "loginData",
  TOKEN: "token",
};

export const APP_NAVIGATION = {
  SINI: "SINI", // SinIn
  SINU: "SINU", // SinUp
  LGOT: "LGOT", // LogOut
  PLAN: "PLAN", // planpage
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  RESET_PASSWORD: "RESET_PASSWORD",
  PERSONALITY_REPORT: "PERSONALITY_REPORT", // personality report
  CAREER_PRE_CONTENT: "CAREER_PRE_CONTENT", // career pre content
  CAREER_REPORT: "CAREER_REPORT",
  BIG_FIVE_REPORT: "BIG_FIVE_REPORT", // big five report
  BIG_FIVE_FACETS_REPORT: "BIG_FIVE_FACETS_REPORT", // big five facets report
  ENNEAGRAM_REPORT: "ENNEAGRAM_REPORT",
  LIKEABILITY_REPORT: "LIKEABILITY_REPORT",
  PERSONALITY_DISORDER_REPORT: "PERSONALITY_DISORDER_REPORT",
  DISC_PERSONALITY_REPORT: "DISC_PERSONALITY_REPORT",
  ADHD_REPORT: "ADHD_REPORT",
  CAREER_PREFERENCE_REPORT: "CAREER_PREFERENCE_REPORT",
  CAREER_PREFERENCE_PRE_CONTENT: "CAREER_PREFERENCE_PRE_CONTENT",
  EMOTIONAL_INTELLIGENCE_REPORT: "EMOTIONAL_INTELLIGENCE_REPORT",
  DIFFICULT_PERSON_REPORT: "DIFFICULT_PERSON_REPORT",
  AUTISM_SPECTRUM_REPORT: "AUTISM_SPECTRUM_REPORT",
  HIGHLY_SENSITIVE_PERSON_REPORT: "HIGHLY_SENSITIVE_PERSON_REPORT",
  ATTACHMENT_STYLE_REPORT: "ATTACHMENT_STYLE_REPORT",
  DYSLEXIA_SCREENING_CHILDREN_REPORT: "DYSLEXIA_SCREENING_CHILDREN_REPORT",
  DYSLEXIA_SCREENING_ADULT_REPORT: "DYSLEXIA_SCREENING_ADULT_REPORT",
  LOVE_STYLE_REPORT: "LOVE_STYLE_REPORT",
  NARCISSISTIC_PERSONALITY_DISORDER_REPORT:
    "NARCISSISTIC_PERSONALITY_DISORDER_REPORT",
  ANTISOCIAL_PERSONALITY_DISORDER_REPORT:
    "ANTISOCIAL_PERSONALITY_DISORDER_REPORT",
  FOUR_TEMPERAMENT_PERSONALITY_REPORT: "FOUR_TEMPERAMENT_PERSONALITY_REPORT",
  DASHBOARD: "DASHBOARD",
  DASHBOARD_B: "DASHBOARD_B",
  SETTINGS: "SETTINGS",
  QUIZ: "QUIZ",
  QUIZ_B: "QUIZ_B",
  CONFIRMATION: "CONFIRMATION",
  ROMANTIC_PERSONAL_REPORT: "ROMANTIC_PERSONAL_REPORT",
  ROMANTIC_COMPATIBILITY_REPORT: "ROMANTIC_COMPATIBILITY_REPORT",
  COLOR_BLIND_REPORT: "COLOR_BLIND_REPORT",
  DEPRESSION_REPORT: "DEPRESSION_REPORT",
  BIPOLAR_DISORDER_REPORT: "BIPOLAR_DISORDER_REPORT",
  CHECKOUT: "CHECKOUT",
  CHECKOUT_B: "CHECKOUT_B",
  CHECKOUT_C: "CHECKOUT_C",
};

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
export const DEFAULT_USER_GUID = "a0000000-0000-0000-0000-00000000000a";
export const MENTAL_HEALTH_NEURODIVERSITY_CATEGORY_ID =
  "7badea3e-776a-497f-8c74-30b2a4b3282a";

export const PORTAL_CD = {
  IT: "IT",
};

export const LOCALE = {
  EN: "en",
  ES: "es",
};

export const FOOTER_LINKS = {
  CONTACT_US: "contact-us",
  PRIVACY_POLICY: "privacy-policy",
  TERMS_CONDITIONS: "terms-of-use",
};

export const EVENT_CATEGORY = {
  PAYMENT: "PAYMENT",
};
export const EVENT_SUBCATEGORY = {
  PAYMENT_FAILED: "PAYMENT_FAILED",
};
export const EVENT_TOPIC = {
  PAYMENT: "PAYMENT",
};
export const NewPricingFlowQueryString = {
  SKUCATEGORY: "skuc",
  CURRENCY: "currency",
  SKUGUID: "skuid",
  USERS: "users",
};

export const REPORT_NOT_FOUND = "report_not_found";

export const PAYMENT_STATUS = {
  FAIL: "FAIL",
  SUCCESS: "SUCCESS",
};

export const PLAN_TYPE = {
  ANNUAL_PLAN: "ANNUAL PLAN",
  FOURTEEN_DAYS_FULL_ACCESS: "14 DAYS FULL ACCESS",
};

export const PLAN_DEFAULT_SKU_SUB_CATEGORY = "M000195";

export const ROMANTIC_COMPATIBILITY_REPORT_TYPE = {
  PERSONALIZED: "personalized",
  COMPATIBILITY: "compatibility",
};

export const ASSESSMENT_STATUS = {
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
};

export const BADGE_TYPE = {
  TEST_COMPLETION: "TEST_COMPLETION",
  INVITE: "INVITE",
  SOCIAL_SHARE: "SOCIAL_SHARE",
};


